import { createContext } from 'react'

const SavedPaymentMethodContext = createContext(null)
export default SavedPaymentMethodContext
